import { Col, InputField, Label, ReactSelectBox } from "client/CommonComponents"
import { CONSTANTS } from "client/utils/constants"
import { isNumber } from 'utils'
import { MaskedTextField } from "@fluentui/react"

const DispositionChoise = (props: any) => {
    const {
        dispositionSubChoiceDropdownList,
        onChangeDispositionSubChoice,
        dispositionSubChoice,
        dispositionData,
        cityOnChange,
        stateOnChange,
        thirdPartyAddress,
        assetDispositionNameOnChange,
        assetDispositionAddress1OnChange,
        assetDispositionAddress2OnChange,
        assetDispositionZipOnChange,
        assetDispositionPhoneOnChange,
        AssetDispostionFieldRef,
        assetDispositionSalePriceOnChange,
        priceFormat,
        assetDispositionTotalPriceOnChange,
        TotalpriceFormat,
        filterOptionAddress1,
        addressSearchText,
        addressListLoad,
        addressDropDownListTemp
    } = props

    return (
        <>
            {(dispositionData?.assetDispositionChoice === CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_LEASED
                || dispositionData?.assetDispositionChoice === CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_OWNED)
                && (
                    <Col xs={12} md={4} lg={4} className='mb-3'>
                        <Label required data-attribute="DispositionSubChoices_Default_Label">{dispositionData?.assetDispositionChoice}</Label>
                        <ReactSelectBox
                            options={dispositionSubChoiceDropdownList}
                            onChange={onChangeDispositionSubChoice}
                            value={dispositionSubChoice.subChoice || ""}
                            selectRef={(element: any) => AssetDispostionFieldRef.current[1] = element}
                            className={dispositionData?.assetDispositionSubChoiceError ? 'controlValidation form-input' : 'form-input'}
                         data-attribute="DispositionSubChoices_Default_SearchSelectBox" />
                        {dispositionData?.assetDispositionSubChoiceError ? <p className='validMessage'>{dispositionData?.assetDispositionSubChoiceError}</p> : ""}
                    </Col>
                )}
            {(dispositionData?.assetDispositionChoice === CONSTANTS.DISPOSITION_CHOICES.SELL_TO_LEASED_THIRD_PARTY
                || dispositionData?.assetDispositionChoice === CONSTANTS.DISPOSITION_CHOICES.SELL_TO_OWNED_THIRD_PARTY)
                && <>
                    <Col xs={12} md={4} lg={4} className='mb-3'>
                        <Label required data-attribute="DispositionSubChoices_Default_Label_2">Name</Label>
                        <InputField
                            name='assetDispositionName'
                            placeholder="Enter Name"
                            value={thirdPartyAddress.assetDispositionName}
                            onChange={(e: any) => assetDispositionNameOnChange(e)}
                            className={dispositionData?.assetDispositionNameError ? 'controlValidation form-input' : 'form-input'}
                        //inputRef={(element: any) => AssetDispostionFieldRef.current[2] = element}
                         data-attribute="DispositionSubChoices_assetDispositionName_Input" />
                        {dispositionData?.assetDispositionNameError ? <p className='validMessage'>{dispositionData?.assetDispositionNameError}</p> : ""}
                    </Col>
                    <Col xs={12} md={4} lg={4} className='mb-3'>
                        <Label required data-attribute="DispositionSubChoices_Default_Label_3">Address 1</Label>
                        <ReactSelectBox
                            options={addressDropDownListTemp}
                            onChange={(e: any, item: any) => assetDispositionAddress1OnChange(e, item)}
                            value={thirdPartyAddress.assetDispositionAddress1?.length ? { label: thirdPartyAddress.assetDispositionAddress1, text: thirdPartyAddress.assetDispositionAddress1 } : ""}
                            placeholder="Search"
                            isSearchable={true}
                            isLoading={addressListLoad}
                            inputValue={addressSearchText}
                            noOptionsMessage={() => "Not Available"}
                            isClearable = {true}
                            onInputChange={(value: any, action: any) => filterOptionAddress1(value, action)}
                            className={dispositionData?.assetDispositionAddress1Error ? 'controlValidation form-input' : 'form-input'}
                         data-attribute="DispositionSubChoices_Default_SearchSelectBox_2" />
                        {dispositionData?.assetDispositionAddress1Error ? <p className='validMessage'>{dispositionData?.assetDispositionAddress1Error}</p> : ""}
                    </Col>
                    <Col xs={12} md={4} lg={4} className='mb-3'>
                        <Label data-attribute="DispositionSubChoices_Default_Label_4">Address 2</Label>
                        <InputField
                            name='assetDispositionAddress2'
                            placeholder="Enter Address 2"
                            value={thirdPartyAddress.assetDispositionAddress2}
                            className={dispositionData?.assetDispositionAddress2Error ? 'controlValidation form-input' : 'form-input'}
                            //inputRef={(element: any) => AssetDispostionFieldRef.current[4] = element}
                            onChange={(e: any) => assetDispositionAddress2OnChange(e)}  data-attribute="DispositionSubChoices_assetDispositionAddress2_Input" />
                        {dispositionData?.assetDispositionAddress2Error ? <p className='validMessage'>{dispositionData?.assetDispositionAddress2Error}</p> : ""}
                    </Col>
                    <Col xs={12} md={4} lg={4} className='mb-3'>
                        <Label required data-attribute="DispositionSubChoices_Default_Label_5">State</Label>
                        <InputField
                            name='assetDispositionState'
                            placeholder="Enter State"
                            value={thirdPartyAddress.assetDispositionState}
                            className={dispositionData?.assetDispositionStateError ? 'controlValidation form-input' : 'form-input'}
                            //inputRef={(element: any) => AssetDispostionFieldRef.current[6] = element}
                            onChange={(e?: any, item?: any) => { stateOnChange(e, item) }}  data-attribute="DispositionSubChoices_assetDispositionState_Input" />
                        {dispositionData?.assetDispositionStateError ? <p className='validMessage'>{dispositionData?.assetDispositionStateError}</p> : ""}
                    </Col>
                    <Col xs={12} md={4} lg={4} className='mb-3'>
                        <Label required data-attribute="DispositionSubChoices_Default_Label_6">City</Label>
                        <InputField
                            name='assetDispositionCity'
                            placeholder="Enter City"
                            value={thirdPartyAddress.assetDispositionCity}
                            className={dispositionData?.assetDispositionCityError ? 'controlValidation form-input' : 'form-input'}
                            //inputRef={(element: any) => AssetDispostionFieldRef.current[5] = element}
                            onChange={(e?: any, item?: any) => { cityOnChange(e, item) }}  data-attribute="DispositionSubChoices_assetDispositionCity_Input" />
                        {dispositionData?.assetDispositionCityError ? <p className='validMessage'>{dispositionData?.assetDispositionCityError}</p> : ""}
                    </Col>
                    <Col xs={12} md={4} lg={4} className='mb-3'>
                        <Label required data-attribute="DispositionSubChoices_Default_Label_7">Zip Code</Label>
                        <InputField
                            name='assetDispositionZip'
                            placeholder="Enter Zip Code"
                            value={thirdPartyAddress.assetDispositionZip}
                            onChange={(e: any) => assetDispositionZipOnChange(e)}
                            onKeyPress={(event: any) => { isNumber(event) }}
                            className={dispositionData?.assetDispositionZipError ? 'controlValidation form-input' : 'form-input'}
                        //inputRef={(element: any) => AssetDispostionFieldRef.current[7] = element}
                         data-attribute="DispositionSubChoices_assetDispositionZip_Input" />
                        {dispositionData?.assetDispositionZipError ? <p className='validMessage'>{dispositionData?.assetDispositionZipError}</p> : ""}
                    </Col>
                    <Col xs={12} md={4} lg={4} className='mb-3'>
                        <Label required data-attribute="DispositionSubChoices_Default_Label_8">Phone #</Label>
                        <MaskedTextField
                            name='assetDispositionPhone'
                            className={dispositionData?.assetDispositionPhoneError ? 'controlValidation form-input' : 'form-input'}
                            mask="999-999-9999"
                            placeholder='Enter Phone'
                            onChange={(e: any, value: any) => assetDispositionPhoneOnChange(value)}
                            value={thirdPartyAddress?.assetDispositionPhone || ""}
                        //componentRef={(element: any) => AssetDispostionFieldRef.current[8] = element}
                        />
                        {dispositionData?.assetDispositionPhoneError ? <p className='validMessage'>{dispositionData?.assetDispositionPhoneError}</p> : ""}
                    </Col>
                    <Col xs={12} md={4} lg={4} className='mb-3'>
                        <Label required data-attribute="DispositionSubChoices_Default_Label_9">Sale price</Label>
                        <InputField
                            name='assetDispositionSalePrice'
                            className={dispositionData?.assetDispositionSalePriceError ? 'controlValidation form-input' : 'form-input'}
                            placeholder="Enter Sale Price"
                            onBlur={(event: any) => priceFormat(event)}
                            prefix={"$"}
                            value={thirdPartyAddress.assetDispositionSalePrice || ""}
                            onChange={(e: any) => assetDispositionSalePriceOnChange(e)}
                            onKeyPress={(event: any) => { isNumber(event) }}
                         data-attribute="DispositionSubChoices_assetDispositionSalePrice_Input" />
                        {dispositionData?.assetDispositionSalePriceError ? <p className='validMessage'>{dispositionData?.assetDispositionSalePriceError}</p> : ""}
                    </Col>
                    <Col xs={12} md={4} lg={4} className='mb-3'>
                        <Label required data-attribute="DispositionSubChoices_Default_Label_10">Total price</Label>
                        <InputField
                            name='assetDispositionTotalPrice'
                            className={dispositionData?.assetDispositionTotalPriceError ? 'controlValidation form-input' : 'form-input'}
                            placeholder="Enter Total Price"
                            onBlur={(event: any) => TotalpriceFormat(event)}
                            prefix={"$"}
                            value={thirdPartyAddress.assetDispositionTotalPrice || ""}
                            onChange={(e: any) => assetDispositionTotalPriceOnChange(e)}
                            onKeyPress={(event: any) => { isNumber(event) }}
                         data-attribute="DispositionSubChoices_assetDispositionTotalPrice_Input" />
                        {dispositionData?.assetDispositionTotalPriceError ? <p className='validMessage'>{dispositionData?.assetDispositionTotalPriceError}</p> : ""}
                    </Col>
                </>}
        </>
    )
}


export default DispositionChoise